import { Component, Input, OnInit } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { IFilterSelection } from '../../../../models/filter-selection.model'

@Component({
    selector: 'app-stored-filter-modal',
    templateUrl: './stored-filter-modal.component.html',
    standalone: false
})
export class StoredFilterModalComponent implements OnInit {
  @Input() filterSelections: { other: IFilterSelection[]; own: IFilterSelection[] }[]
  @Input() sid: number

  private _myFilters: IFilterSelection[] = []
  private _sharedFilters: IFilterSelection[] = []

  public get myFilters(): IFilterSelection[] {
    return this._myFilters
  }

  public get sharedFilters(): IFilterSelection[] {
    return this._sharedFilters
  }

  constructor(private activeModal: NgbActiveModal) {}

  public onSelect(sid: number): void {
    this.activeModal.close({
      selectionId: sid,
    })
  }

  public onRemove(): void {
    this.activeModal.close({
      selectionId: null,
    })
  }

  public closeModal(): void {
    this.activeModal.close()
  }

  ngOnInit(): void {
    if (this.filterSelections['own']) {
      for (let i = 0; i < this.filterSelections['own'].length; i++) {
        if (this.filterSelections['own'][i].isPublic) {
          this._sharedFilters.push(this.filterSelections['own'][i])
        } else {
          this._myFilters.push(this.filterSelections['own'][i])
        }
      }
    }
    if (this.filterSelections['other']) {
      for (let i = 0; i < this.filterSelections['other'].length; i++) {
        this._sharedFilters.push(this.filterSelections['other'][i])
      }
    }
  }
}
